<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat class="pb-0 pt-0">
					<v-card-text class="pa-2">
						<v-row class="d-flex justify-space-between">
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-left align-center pa-2">
									{{ $t('titles.guaranteedRemaining') }}</v-card-title
								>
							</v-col>
							<v-col
								class="d-flex justify-end align-center pa-2 pb-0 pt-0"
								v-if="paymentContractStatus == 1"
							>
								<v-btn color="basicButton" @click="addItem()">
									{{ $t('buttons.addItem') }}
									<v-icon small class="ml-2">fas fa-plus</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0">
								<v-simple-table fixed-header dense height="400px">
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.type') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.course') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.quantity') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.unitPrice') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.unitDiscount2') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.unitDiscount') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.neto') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.bruto') }}
												</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(item, key) in items"
												:key="key"
												:class="{ 'cursor-pointer': true }"
											>
												<td
													style="white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{ item.payment_contract_item_type.name }}
												</td>
												<td
													style="white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{ item.course_id != null ? item.course.name : '' }}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{ item.quantity }}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{
														item.unit_price != null
															? Number.isInteger(item.unit_price)
																? item.unit_price.toLocaleString('hr') + ',00'
																: /^\d+\.\d{1}$/.test(item.unit_price.toString())
																? item.unit_price.toLocaleString('hr') + '0'
																: item.unit_price.toLocaleString('hr')
															: ''
													}}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{
														item.unit_discount_percentage != null
															? Number.isInteger(item.unit_discount_percentage)
																? item.unit_discount_percentage.toLocaleString('hr') +
																  ',00'
																: /^\d+\.\d{1}$/.test(
																		item.unit_discount_percentage.toString()
																  )
																? item.unit_discount_percentage.toLocaleString('hr') +
																  '0'
																: item.unit_discount_percentage.toLocaleString('hr')
															: ''
													}}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{
														item.unit_discount != null
															? Number.isInteger(item.unit_discount)
																? item.unit_discount.toLocaleString('hr') + ',00'
																: /^\d+\.\d{1}$/.test(item.unit_discount.toString())
																? item.unit_discount.toLocaleString('hr') + '0'
																: item.unit_discount.toLocaleString('hr')
															: ''
													}}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{
														item.total != null
															? Number.isInteger(item.total)
																? item.total.toLocaleString('hr') + ',00'
																: /^\d+\.\d{1}$/.test(item.total.toString())
																? item.total.toLocaleString('hr') + '0'
																: item.total.toLocaleString('hr')
															: ''
													}}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="$route.params.id != 0 ? editItem(item.id) : null"
												>
													{{
														item.total_bruto != null
															? Number.isInteger(item.total_bruto)
																? item.total_bruto.toLocaleString('hr') + ',00'
																: /^\d+\.\d{1}$/.test(item.total_bruto.toString())
																? item.total_bruto.toLocaleString('hr') + '0'
																: item.total_bruto.toLocaleString('hr')
															: ''
													}}
												</td>
												<td v-if="paymentContractStatus == 1">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																icon
																x-small
																v-bind="attrs"
																v-on="on"
																@click="deleteClick(item.id)"
															>
																<v-icon small>fas fa-trash</v-icon>
															</v-btn>
														</template>
														<span>{{ $t('tooltips.deleteItem') }}</span>
													</v-tooltip>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<Modal :show-modal="showModal">
			<PaymentContractItem
				:itemId="itemId"
				:vatExists="vatExists"
				:paymentContractStatus="paymentContractStatus"
				@close="closeModal"
				@addTempItem="handleAddTempItem"
			></PaymentContractItem>
		</Modal>
	</v-container>
</template>

<script>
import Modal from '../../trinkets/Modal';
import PaymentContractItem from './PaymentContractItem';

export default {
	name: 'paymentContractItems',
	components: { Modal, PaymentContractItem },
	props: {
		paymentContractStatus: [String, Number],
		vatExists: Boolean,
	},
	data: function () {
		return {
			items: [],
			showModal: false,
			itemId: 0,
			itemTempId: 1,
		};
	},
	watch: {
		vatExists(newVal) {
			if (this.$route.params.id == 0) {
				this.updateValues(newVal);
				this.$emit('tempItems', this.items);
			}
		},
	},
	methods: {
		addItem() {
			this.showModal = true;
		},
		editItem(id) {
			this.itemId = id;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.itemId = 0;
		},
		updateValues(vatExist) {
			if (vatExist) {
				for (const item of this.items) {
					item['vat_total'] = parseFloat(
						(
							(item['unit_price'] - (item['unit_discount_percentage'] / 100) * item['unit_price']) *
							item['quantity'] *
							(item['tax'] / 100)
						).toFixed(2)
					);
					item['total_bruto'] = parseFloat(
						(
							(item['unit_price'] - (item['unit_discount_percentage'] / 100) * item['unit_price']) *
							item['quantity'] *
							(item['tax'] / 100 + 1)
						).toFixed(2)
					);
				}
			} else {
				for (const item of this.items) {
					item['vat_total'] = 0;
					item['total_bruto'] = parseFloat(
						(
							(item['unit_price'] - (item['unit_discount_percentage'] / 100) * item['unit_price']) *
							item['quantity']
						).toFixed(2)
					);
				}
			}
		},
		handleAddTempItem(item) {
			this.showModal = false;
			this.itemId = 0;
			item['id'] = this.itemTempId++;
			this.items.push(item);
			this.items = this.items;
			this.$emit('tempItems', this.items);
		},
		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					if (this.$route.params.id == 0) {
						let indexToDelete = this.items.findIndex((obj) => obj.id === id);
						this.items.splice(indexToDelete, 1);
						this.$emit('tempItems', this.items);
					} else {
						vm.$APICall(
							'delete',
							'payment-contract-items/' + id + '/delete',
							{ payment_contract_id: this.$route.params.id, id: id },
							(data, success) => {
								if (success) {
									vm.$notify(vm.$t('alerts.basicDelete'));
									vm.reloadData();
									vm.$modalBus.$emit('reloadPaymentContract');
								} else {
									vm.$alert(vm.$t('alerts.basicError'));
								}
							}
						);
					}
				}
			});
		},
		reloadData() {
			let vm = this;
			this.$APICall(
				'get',
				'payment-contract-items/' + this.$route.params.id,
				null,
				(data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data.items));
						vm.items = usableData;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {
		let vm = this;

		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadPaymentContractItems', () => {
			vm.reloadData();
		});

		if (this.$route.params.id != 0) {
			this.reloadData();
		}
	},
};
</script>

<style scoped></style>
